import { Tag } from '../types/tutorials.types';

/**
 * Main category tags for organizing tutorials and FAQs
 */
export const TUTORIAL_TAGS: Tag[] = [
  {
    id: 'sesiones',
    name: 'sesiones',
    displayName: 'Sesiones',
    subTags: [
      { id: 'iniciar-sesion', name: 'iniciar-sesion', displayName: 'Iniciar Sesión', parentTag: 'sesiones' },
      { id: 'cerrar-sesion', name: 'cerrar-sesion', displayName: 'Cerrar Sesión', parentTag: 'sesiones' },
      { id: 'arqueo-caja', name: 'arqueo-caja', displayName: 'Arqueo de Caja', parentTag: 'sesiones' }
    ]
  },
  {
    id: 'turnos',
    name: 'turnos',
    displayName: 'Turnos',
    subTags: [
      { id: 'crear-turno', name: 'crear-turno', displayName: 'Crear Turno', parentTag: 'turnos' },
      { id: 'cambiar-turno', name: 'cambiar-turno', displayName: 'Cambiar Turno', parentTag: 'turnos' },
      { id: 'cuadratura-turno', name: 'cuadratura-turno', displayName: 'Cuadratura de Turno', parentTag: 'turnos' }
    ]
  },
  {
    id: 'pedidos',
    name: 'pedidos',
    displayName: 'Pedidos',
    subTags: [
      { id: 'crear-pedido', name: 'crear-pedido', displayName: 'Crear Pedido', parentTag: 'pedidos' },
      { id: 'editar-pedido', name: 'editar-pedido', displayName: 'Editar Pedido', parentTag: 'pedidos' },
      { id: 'eliminar-pedido', name: 'eliminar-pedido', displayName: 'Eliminar Pedido', parentTag: 'pedidos' },
      { id: 'mover-productos', name: 'mover-productos', displayName: 'Mover Productos', parentTag: 'pedidos' },
      { id: 'juntar-mesas', name: 'juntar-mesas', displayName: 'Juntar Mesas', parentTag: 'pedidos' },
      { id: 'separar-cuenta', name: 'separar-cuenta', displayName: 'Separar Cuenta', parentTag: 'pedidos' },
      { id: 'modo-hoster', name: 'modo-hoster', displayName: 'Modo Hoster', parentTag: 'pedidos' }
    ]
  },
  {
    id: 'menus',
    name: 'menus',
    displayName: 'Menús',
    subTags: [
      { id: 'crear-menu', name: 'crear-menu', displayName: 'Crear Menú', parentTag: 'menus' },
      { id: 'editar-menu', name: 'editar-menu', displayName: 'Editar Menú', parentTag: 'menus' },
      { id: 'categorias-menu', name: 'categorias-menu', displayName: 'Categorías', parentTag: 'menus' }
    ]
  },
  {
    id: 'items',
    name: 'items',
    displayName: 'Items',
    subTags: [
      { id: 'crear-item', name: 'crear-item', displayName: 'Crear Item', parentTag: 'items' },
      { id: 'editar-item', name: 'editar-item', displayName: 'Editar Item', parentTag: 'items' },
      { id: 'precios-item', name: 'precios-item', displayName: 'Gestión de Precios', parentTag: 'items' }
    ]
  },
  {
    id: 'clientes',
    name: 'clientes',
    displayName: 'Clientes',
    subTags: [
      { id: 'gestion-clientes', name: 'gestion-clientes', displayName: 'Gestión de Clientes', parentTag: 'clientes' },
      { id: 'membresias', name: 'membresias', displayName: 'Membresías', parentTag: 'clientes' },
      { id: 'fidelizacion', name: 'fidelizacion', displayName: 'Fidelización', parentTag: 'clientes' },
      { id: 'punto-digital', name: 'punto-digital', displayName: 'Mi Punto Digital', parentTag: 'clientes' }
    ]
  },
  {
    id: 'pagos',
    name: 'pagos',
    displayName: 'Pagos',
    subTags: [
      { id: 'metodos-pago', name: 'metodos-pago', displayName: 'Métodos de Pago', parentTag: 'pagos' },
      { id: 'propinas', name: 'propinas', displayName: 'Propinas', parentTag: 'pagos' },
      { id: 'descuentos-pago', name: 'descuentos-pago', displayName: 'Descuentos', parentTag: 'pagos' }
    ]
  },
  {
    id: 'descuentos',
    name: 'descuentos',
    displayName: 'Descuentos',
    subTags: [
      { id: 'crear-descuento', name: 'crear-descuento', displayName: 'Crear Descuento', parentTag: 'descuentos' },
      { id: 'cupones', name: 'cupones', displayName: 'Cupones', parentTag: 'descuentos' }
    ]
  },
  {
    id: 'usuarios',
    name: 'usuarios',
    displayName: 'Usuarios',
    subTags: [
      { id: 'crear-usuario', name: 'crear-usuario', displayName: 'Crear Usuario', parentTag: 'usuarios' },
      { id: 'permisos', name: 'permisos', displayName: 'Permisos', parentTag: 'usuarios' },
      { id: 'roles', name: 'roles', displayName: 'Roles', parentTag: 'usuarios' }
    ]
  },
  {
    id: 'configuracion',
    name: 'configuracion',
    displayName: 'Configuración',
    subTags: [
      { id: 'config-general', name: 'config-general', displayName: 'General', parentTag: 'configuracion' },
      { id: 'config-mesas', name: 'config-mesas', displayName: 'Mesas', parentTag: 'configuracion' },
      { id: 'config-impresion', name: 'config-impresion', displayName: 'Impresión', parentTag: 'configuracion' }
    ]
  },
  {
    id: 'reportes',
    name: 'reportes',
    displayName: 'Reportes',
    subTags: [
      { id: 'ventas-reportes', name: 'ventas-reportes', displayName: 'Ventas', parentTag: 'reportes' },
      { id: 'inventario-reportes', name: 'inventario-reportes', displayName: 'Inventario', parentTag: 'reportes' }
    ]
  },
  {
    id: 'impresion',
    name: 'impresion',
    displayName: 'Impresión',
    subTags: [
      { id: 'config-impresoras', name: 'config-impresoras', displayName: 'Configurar Impresoras', parentTag: 'impresion' },
      { id: 'imprimir-recibos', name: 'imprimir-recibos', displayName: 'Imprimir Recibos', parentTag: 'impresion' }
    ]
  },
  {
    id: 'marketing-digital',
    name: 'marketing-digital',
    displayName: 'Marketing Digital',
    subTags: [
      { id: 'presencia-web', name: 'presencia-web', displayName: 'Presencia Web', parentTag: 'marketing-digital' },
      { id: 'redes-sociales', name: 'redes-sociales', displayName: 'Redes Sociales', parentTag: 'marketing-digital' },
      { id: 'qr-codes', name: 'qr-codes', displayName: 'Códigos QR', parentTag: 'marketing-digital' }
    ]
  }
];
